export default __webpack_public_path__ + "static/media/icon-conversation.0cd41906.svg";